<template>
  <div class="about">
    <div class="container">
      <div class="title">
        <p>关于我们</p>
        <span>About us</span>
        <i></i>
      </div>
      <div class="con">
        <div class="img">
          <img :src="con.cover_img" alt="" />
        </div>
        <div class="text">
          <div class="title">
            <i></i>
            <p>{{ con.title }}</p>
          </div>
          <div class="info" v-html="con.contents"></div>
          <router-link tag="a" :to="$Router.about.path" rel="nofollow">[查看详情]</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from './about'

export default {
  name: 'about',
  data () {
    return {
      id: 2,
      cate_id: '',
      con: {}
    }
  },
  created () {
    service.getColumnId(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./about";
</style>



// WEBPACK FOOTER //
// src/components/index/about/about.vue